import React from 'react';
import {Navigate, Route, Routes} from 'react-router-dom';
import DefaultLayout from "../Layout/DefaultLayout";
import Home from "../Pages/Home";
import TermsOfUse from "../Pages/TermsOfUse";
import PrivacyPolicy from "../Pages/PrivacyPolicy";
import {HOME_URL, PRIVACY_POLICY_URL, TERMS_AND_CONDITIONS_URL} from "../Util/routes";

const PagesRoutes = () => (
    <DefaultLayout>
        <Routes>
            <Route exact path={HOME_URL} element={<Home/>} />
            <Route exact path={TERMS_AND_CONDITIONS_URL} element={<TermsOfUse/>} />
            <Route exact path={PRIVACY_POLICY_URL} element={<PrivacyPolicy/>} />
            <Route exact path="*" element={<Navigate to="/transformation"/>} />
        </Routes>
    </DefaultLayout>
);

export default PagesRoutes;
